import { useLingui } from "@lingui/react";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const Color = ({ color }: SpecProps<"color">) => {
  const { i18n } = useLingui();

  if (color == null || color === "") {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.color",
    message: "Color",
    comment: "Field for 'color' in ad specification",
  });
  return <FieldValuePair field={field} value={color} />;
};
